import React from 'react';
import styled from 'styled-components';
import { navy, white } from '@zocdoc/branding/colors';

import { Icon } from './_base';

const RadioActiveSVG = styled(Icon).attrs({ viewBox: '0 0 16 16' })``;

const RadioActive = ({ color = navy, backgroundColor = white, ...props }) => (
    <RadioActiveSVG
        data-test="icon-radio-active"
        {...props}
    >
        <circle
            cx="8"
            cy="8"
            fill={color}
            r="8"
        />
        <circle
            cx="8"
            cy="8"
            fill={backgroundColor}
            r="7"
        />
        <circle
            cx="8"
            cy="8"
            fill={color}
            r="4"
        />
    </RadioActiveSVG>
);

export {
    RadioActive as default,
    RadioActive,
};
